import React, { useState, Fragment } from 'react'
import styled from '@emotion/styled'

import { AuthorizedDisplay } from '@containers/common/auth'
import { FlexContainer, YSpacing } from '@components/common'
import { CompanyManager, SchemaManager } from '@containers/hubspot'
import { colors } from '../../../constants'

const TABS = [
  {
    label: 'Companies',
    value: 'companies',
    restricted: false,
  },
  {
    label: 'Schemas',
    value: 'schemas',
    restricted: true,
  },
]

const HubspotPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState('companies')

  return (
    <Fragment>
      <FlexContainer flexDirection="column">
        <YSpacing height="40px" />
        <HubspotPageBody>
          <h1>Hubspot Dashboard</h1>
          <FlexContainer
            flexDirection="row"
            width="100%"
            alignItems="center"
            gap="5px"
          >
            {TABS.map(({ label, value, restricted }) => {
              const tab = (
                <HubspotPageTab
                  key={value}
                  active={activeTab === value}
                  onClick={() => setActiveTab(value)}
                >
                  {label}
                </HubspotPageTab>
              )

              if (restricted) {
                return (
                  <AuthorizedDisplay
                    key={value}
                    roles={['master admin']}
                    width="fit-content"
                  >
                    {tab}
                  </AuthorizedDisplay>
                )
              } else {
                return tab
              }
            })}
          </FlexContainer>
          <YSpacing height="30px" />
          {activeTab === 'companies' && <CompanyManager />}
          {activeTab === 'schemas' && <SchemaManager />}
        </HubspotPageBody>
      </FlexContainer>
    </Fragment>
  )
}

export default HubspotPage

const HubspotPageBody = styled.div`
  width: 100vw;
  padding: 0 20px;
  h1 {
    font-size: 25px;
    margin-bottom: 10px;
    font-weight: 700;
    color: ${colors.gray400};
  }
`

const HubspotPageTab = styled.div<{ active: boolean }>`
  font-size: 20px;
  border-bottom: ${(props) =>
    props.active ? `1px solid ${colors.orange}` : 'none'};
  font-weight: ${(props) => (props.active ? `700` : `600`)};
  padding: 3px 2px;
`
